import IRoomFormData from "../../../Interfaces/roomFormData";
import IRoomOverview from "../../../Interfaces/roomOverview";
import CRStep3VisualizationComponent from "../../RoomForm/Step3/Visualization/CRStep3Visualization.component";
import styles from './CenterDistanceOverview.module.css'

const CenterDistanceOverviewComponent: React.FC<IRoomOverview> = (params: IRoomOverview) => {
    return (
        <div>
            <div className={styles.overview__container}>
                <CRStep3VisualizationComponent  {...{ ...params as unknown as IRoomFormData }} />
            </div>
        </div>
    )
}

export default CenterDistanceOverviewComponent;